import { Alert, IconButton, Box } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useEffect, useState } from "react";

type Props = {
  message: string | null;
  onClose?: () => void;
};

const STORAGE_KEY = "notificationBannerDismissed";
const EXPIRY_TIME = 24 * 60 * 60 * 1000 * 7; // 7 days

export default function NotificationBanner({ message, onClose }: Props) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!message) {
      setVisible(false);
      return;
    }

    const dismissedTime = localStorage.getItem(STORAGE_KEY);

    if (!dismissedTime) {
      setVisible(true);
      return;
    }

    const now = Date.now();

    if (now - Number(dismissedTime) > EXPIRY_TIME) {
      setVisible(true);
    }
  }, [message]);

  const handleClose = () => {
    localStorage.setItem(STORAGE_KEY, Date.now().toString());
    setVisible(false);
    onClose?.();
  };

  if (!visible || !message) return null;

  return (
    <Alert
      severity="info"
      icon={false}
      sx={{
        borderRadius: 0,
        position: "fixed",
        top: 0,
        width: "100%",
        zIndex: 2000,
        py: 1,
        px: 2,
      }}
    >
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "1fr auto 1fr",
          alignItems: "center",
          width: "100%",
        }}
      >
        {/* Left spacer */}
        <Box />

        {/* Perfectly centered text */}
        <Box sx={{ textAlign: "center", fontWeight: 500 }}>{message}</Box>

        {/* Right close button */}
        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
          <IconButton size="small" onClick={handleClose}>
            <CloseIcon fontSize="inherit" />
          </IconButton>
        </Box>
      </Box>
    </Alert>
  );
}
